import { AdminLeaderboardHeader } from './components/AdminLeaderboardHeader/AdminLeaderboardHeader';
import { AdminLeaderboardContent } from './components/AdminLeaderboardContent/AdminLeaderboardContent';
import { useLeaderboardSummary } from '../../hooks/useLeaderboardSummary';
import { useActiveLeaderboardEvent } from '../../hooks/useActiveLeaderboardEvent';
import './AdminLeaderboard.scss';

export const AdminLeaderboard = () => {
  const { activeEvent } = useActiveLeaderboardEvent();
  const { summary } = useLeaderboardSummary(activeEvent?.id);

  return (
    <div className="leaderboard-page">
      <h1>Leaderboard</h1>
      <AdminLeaderboardHeader summary={summary} />
      <AdminLeaderboardContent summary={summary} />
    </div>
  );
};
